<template>
    <Tab :tab="tablist">
        <template v-slot:content0>
            <h4 class="mt-3" @click="changeState(0)">
                <i class="fas fa-times text-danger"></i>
            </h4>
            <div class="row" id="addAnvaMoshtarian">

                <div class="col-12 col-md-4 text-right mt-3 mb-3">
                    <small id="LblCodeTafsiliType">کد نوع مشتری</small>
                    <input class="form-control text-left required" type="text" @keypress="$ValidNumber($event, 10)"
                        id="CodeTafsiliType" v-model="DataAxiosEdit.codeTafsiliType" />
                </div>
                <div class="col-12 col-md-4 text-right mt-3 mb-3">
                    <small id="LblNameTafsiliType">نام نوع مشتری</small>
                    <input class="form-control text-right required" type="text" id="NameTafsiliType"
                        v-model="DataAxiosEdit.nameTafsiliType" />
                </div>
                <div class="col-12 col-md-4 text-right mt-3 mb-3">
                    <small id="LblTedadZemanat">تعداد ضمانت</small>
                    <input class="form-control text-right " type="text" id="TedadZemanat"
                        v-model="DataAxiosEdit.tedadZemanat" @keypress="$ValidNumber($event, 10)" />
                </div>
                <div class="col-12 col-md-4 text-right mt-3 mb-3">
                    <small id="LblMablaghZemanat">مبلغ ضمانت</small>
                    <input class="form-control text-right " type="text" id="MablaghZemanat"
                        v-model="DataAxiosEdit.mablaghZemanat" @keypress="$ValidNumber($event, 15)"
                        @keyup="DataAxiosEdit.mablaghZemanat = $PutCommatoInput_New($event);" />
                </div>
                <div class="col-12 col-md-3 text-right mt-3 mb-3">
                    <small id="LblPishFarz">پیش فرض</small>
                    <span class="form-control p-1">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input InputText" @click="statusChk($event)"
                                :checked="DataAxiosEdit.pishFarz" v-model="DataAxiosEdit.pishFarz" id="DefaultHoze" />
                            <label class="custom-control-label" for="DefaultHoze">پیش
                                فرض</label>
                        </div>
                    </span>
                </div>
                <div class="justify-content-center col-12 col-md-4 p-2" style="margin-top: 27px;">
                    <button class=" btn btn-success col-10" @click="editItem()">
                        ویرایش
                    </button>
                </div>
            </div>
        </template>
        <template v-slot:content1>
            <h4 class="mt-3" @click="changeState()">
                <i class="fas fa-times text-danger"></i>
            </h4>
            <DastresiCard @submitTafsiliTypeGrp="submitTafsiliTypeGrp" :editItem="DataAxiosEdit" @addAccesse="addAccesse"
                :jobName="DataAxiosEdit.nameTafsiliType" :idItem="DataAxiosEdit.id"></DastresiCard>
        </template>
    </Tab>


</template>

<script>
import DastresiCard from './DastresiCard.vue'
import Tab from '@/components/Tab/Tab.vue'
export default {
    components: { DastresiCard, Tab },
    props: ['idItemForEdit'],
    data() {
        return {
            item: {},
            tablist: [
                { header: 'جزئیات مشتری', active: this.isactive(0) },
                { header: 'حق دسترسی پست', active: this.isactive(1) }
            ],
            DataAxiosEdit: {}
        }
    },

    created() {
        this.getData()
    },

    methods: {
        getData() {
            let axios = {
                Action: 'AnvaMoshtarian/GetDetailForUpdate/' + this.idItemForEdit,
                Method: 'get',
                ArryfildValue: {}
            }
            this.$PostData(axios).then((res) => {
                this.DataAxiosEdit = res
            }).catch((err) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطا در خواندن اطلاعات', 'error', 2000)
                console.error(err)
            })
        },
        checkForm() {
            let isValid = true
            if (this.DataAxiosEdit.nameTafsiliType == null) {
                this.$mySweetDefaultTost('عملیات ناموفق', 'نام نوع مشتری الزامی است', 'error', 3000)
                isValid = false
            }
            else {
                var value = this.DataAxiosEdit.nameTafsiliType.replace(/\s/g, '')
                if (value == '') {
                    this.$mySweetDefaultTost('عملیات ناموفق', 'نام نوع مشتری الزامی است', 'error', 3000)
                    isValid = false

                }
            }

            if (this.DataAxiosEdit.codeTafsiliType == null) {
                this.$mySweetDefaultTost('عملیات ناموفق', 'کد نوع مشتری الزامی است', 'error', 3000)
                isValid = false
            }
            else {
                var value = this.DataAxiosEdit.codeTafsiliType.replace(/\s/g, '')
                if (value == '') {
                    this.$mySweetDefaultTost('عملیات ناموفق', 'کد نوع مشتری الزامی است', 'error', 3000)
                    isValid = false
                }
            }
            return isValid
        },
        editItem() {

            if (!this.checkForm()) {
                return
            }

            this.DataAxiosEdit.TblShobeId = this.shobeId
            this.DataAxiosEdit.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
            let DataAxois = {
                Action: 'AnvaMoshtarian',
                Method: 'put',
                ArryfildValue: this.DataAxiosEdit
            }
            this.$PostData(DataAxois).then((res) => {
                if (res.status == "Ok") {
                    this.$mySweetDefaultTost('عملیات موفق', 'آیتم با موفقیت ویرایش شد', 'success', 2000)
                    this.changeState(0)
                    this.$emit('editedItem', {})
                    this.$nextTick(() => {
                        this.render = true
                    })
                    this.DataAxiosEdit = {}
                } else {
                    this.$mySweetDefaultTost('عملیات ناموفق', res.msg, 'error', 5000)
                }

            }).catch((err) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error(err)
            })
        },
        changeState() {
            this.$emit('changeState', {})
        },
        isactive(num) {
            return this.active == num
        },
        submitTafsiliTypeGrp() {
            this.editItem()
        },
        addAccesse(){
            this.changeState(0)
        }
    },

}

</script>

<style scoped>

</style>